import { NULL } from "constants/primitives";
import WidgetConfig, { createWidgetConfig } from "helpers/init/WidgetConfig";
import { consentLogger } from "helpers/logger";
import createPromise from "helpers/createPromise";
import hasConsentExpired from "helpers/consent/hasConsentExpired";
import deleteTCFConsent from "./deleteTCFConsent";
import shouldResetConsent from "helpers/consent/shouldResetConsent";
import resetTCFConsent from "./resetTCFConsent";
import type { ITCFConsent } from "../TCFConsentProvider/types";

// This function checks if consent should be reset/removed after being loaded
const processTCFConsentFromStorage = (
  consent: ITCFConsent,
  consentTimestamp: number | null = NULL,
  widgetConfig: WidgetConfig = createWidgetConfig()
) => {
  return createPromise<ITCFConsent | null>((resolve) => {
    const storedConsent = { ...consent };
    // TODO: HANDLE BULK CONSENT
    const lastConsentReset = widgetConfig.lastConsentReset;

    // check for expired consent
    if (
      consentTimestamp &&
      hasConsentExpired(consentTimestamp, widgetConfig.consentLifetime)
    ) {
      // return deleteTCFConsent(bulkConfig).finally(() => resolve(NULL));
      deleteTCFConsent(widgetConfig.bulkConsent).finally(() => resolve(NULL));
    }
    // check consent reset request
    if (
      consentTimestamp &&
      shouldResetConsent(consentTimestamp, lastConsentReset)
    ) {
      consentLogger("detected reset request, resetting...");
      return resetTCFConsent(widgetConfig.bulkConsent).finally(() => {
        consentLogger("reset success");
        resolve(NULL);
      });
    }

    resolve({ ...storedConsent });
    return;
  });
};

export default processTCFConsentFromStorage;
